module.exports = __webpack_public_path__ + "static/media/filip.882841e1.png";